import {FinancingCompositionScene} from '@dms/api/shared';

import {LayerBox} from '../types/CompositionEditorAction';

// New layers start centered and sized relative to the canvas so they are visible on any canvas.
export const createCenteredLayerBox = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>,
  widthRatio: number,
  heightRatio: number
): LayerBox => {
  const width = Math.round(canvas.width * widthRatio);
  const height = Math.round(canvas.height * heightRatio);
  return {
    x: Math.round((canvas.width - width) / 2),
    y: Math.round((canvas.height - height) / 2),
    width,
    height,
  };
};
